import { appConfig } from "@/app/app-config";

let manifestObjectUrl: string | null = null;

function ensureMetaTag(name: string): HTMLMetaElement {
  let tag = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (!tag) {
    tag = document.createElement("meta");
    tag.name = name;
    document.head.appendChild(tag);
  }
  return tag;
}

function ensureLinkTag(rel: string): HTMLLinkElement {
  let tag = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!tag) {
    tag = document.createElement("link");
    tag.rel = rel;
    document.head.appendChild(tag);
  }
  return tag;
}

function resolveThemeColor(): string {
  return appConfig.customColorTheme || appConfig.splashScreenBg || "#0f172a";
}

function resolveIconUrl(): string {
  return appConfig.splashScreen || "/app-splash.png";
}

export function applyWebAppMetadata(): void {
  if (typeof document === "undefined") return;

  const appName = appConfig.appName || "Switch";
  const themeColor = resolveThemeColor();
  const iconUrl = resolveIconUrl();

  document.title = appName;
  ensureMetaTag("theme-color").content = themeColor;
  ensureMetaTag("apple-mobile-web-app-capable").content = "yes";
  ensureMetaTag("apple-mobile-web-app-status-bar-style").content = "black-translucent";
  ensureMetaTag("apple-mobile-web-app-title").content = appName;

  const appleTouchIcon = ensureLinkTag("apple-touch-icon");
  appleTouchIcon.href = iconUrl;

  const manifestLink = ensureLinkTag("manifest");
  const manifest = {
    id: "/",
    name: appName,
    short_name: appName.slice(0, 12),
    description: `${appName} secure messaging`,
    start_url: "/",
    scope: "/",
    display: "standalone",
    theme_color: themeColor,
    background_color: themeColor,
    icons: [
      {
        src: iconUrl,
        sizes: "192x192",
        type: "image/png",
        purpose: "any maskable",
      },
      {
        src: iconUrl,
        sizes: "512x512",
        type: "image/png",
        purpose: "any maskable",
      },
    ],
  };

  if (manifestObjectUrl) {
    URL.revokeObjectURL(manifestObjectUrl);
  }
  manifestObjectUrl = URL.createObjectURL(
    new Blob([JSON.stringify(manifest)], { type: "application/manifest+json" })
  );
  manifestLink.href = manifestObjectUrl;
}
